const SidebarFooter = () => {
    return(
        <div className="sidebar-footer">
            <div>Versão 1.1.2</div>
            <div>© Smart Olfativos</div>
        </div>
    )
}

export default SidebarFooter;